import React, { useLayoutEffect, useState } from 'react';
import { theme } from 'antd';
import { ShopOutlined } from '@ant-design/icons';
import './EcommerceWorkspace.css';

export function useEcommerceWorkspaceStyle(): React.CSSProperties {
  const { token } = theme.useToken();
  return {
    '--ec-bg': token.colorBgContainer,
    '--ec-soft': token.colorFillAlter,
    '--ec-line': token.colorBorderSecondary,
    '--ec-text': token.colorText,
    '--ec-muted': token.colorTextSecondary,
    '--ec-heading': token.colorTextHeading,
    '--ec-accent': token.colorPrimary,
    '--ec-selected': token.controlItemBgActive,
    '--ec-success': token.colorSuccess,
    '--ec-danger': token.colorError,
    '--ec-warning': token.colorWarning,
  } as React.CSSProperties;
}

export function EcommerceFilterField({ id, label, children }: {
  id: string; label: string; children: React.ReactNode;
}) {
  return <div className="ecommerce-workspace__field">
    <label htmlFor={id}>{label}</label>
    {children}
  </div>;
}

// Le calcul tient compte de la navigation réelle, de la barre de sélection et
// des sections dépliées, plutôt que d'imposer une hauteur liée à la maquette.
export function useEcommerceTableHeight() {
  const [tableNode, setTableNode] = useState<HTMLDivElement | null>(null);
  const [tableHeight, setTableHeight] = useState(320);
  useLayoutEffect(() => {
    if (!tableNode) return;
    const measure = () => setTableHeight(Math.max(220, Math.min(760,
      Math.floor(window.innerHeight - tableNode.getBoundingClientRect().top - 126))));
    measure();
    window.addEventListener('resize', measure);
    const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(measure);
    if (tableNode.parentElement) observer?.observe(tableNode.parentElement);
    return () => {
      observer?.disconnect();
      window.removeEventListener('resize', measure);
    };
  }, [tableNode]);
  return { tableRef: setTableNode, tableHeight };
}

export function ProductThumbnail({ src, name }: { src?: string; name: string }) {
  const [failedUrl, setFailedUrl] = useState<string>();
  return <div className="ecommerce-workspace__thumbnail">
    {src && failedUrl !== src
      ? <img src={src} alt={name} loading="lazy" onError={() => setFailedUrl(src)} />
      : <ShopOutlined aria-label="Photo indisponible" />}
  </div>;
}
